import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import DotIcon from '@material-ui/icons/Lens';

import securityDetailsStyles from './securityDetails.module.css';
import Grid from '@material-ui/core/Grid';
import Select from 'react-select';

import commonStyles from '../../../../common/common.module.css';

const styles = (theme: Theme) =>

  createStyles({
    textField: {
      color: 'var(--primaryblue)'
    },
    input: {
      color: 'var(--primaryblue)',
    },
    blue: {
      color: 'var(--primaryblue)'
    },
    grey: {
      color: 'rgb(0,0,0,0.26)',
      fontSize: '14px'
    },
    red: {
      color: 'red',
      fontSize: 18,
      marginTop: '18px',
      marginLeft: '8px',
    },
    green: {
      color: 'green',
      fontSize: 18,
      marginTop: '18px',
      marginLeft: '8px',
    },
    textFieldWidth: {
      width: '100%'
    },
    select: {
      zIndex: 4
    },
    selectcss: {
      '& .css-yk16xz-control, & .css-1pahdxg-control, & .css-1fhf3k1-control':{
        borderColor: 'transparent',
        borderRadius: 'var(--ip-br)',
        fontSize: '12px',
        minHeight: '27px !important',
        boxShadow: 'none',
        '&:hover':{
          border: '1px solid var(--primaryblue)',
        }
      },
      '& .css-tlfecz-indicatorContainer, & .css-1gtu0rj-indicatorContainer': {
        padding: '0 4px' 
      },
      '& .css-1okebmr-indicatorSeparator, & .css-109onse-indicatorSeparator':{
        display: 'none'
      },
      '& .css-g1d714-ValueContainer' : {
        paddingTop: '0',
        paddingBottom: '0'  
      }
    },
  });

interface CarrierDetailsProps {
  classes: any;
  carrier: Option;
  handleChange: (event: React.ChangeEvent<HTMLInputElement>, type: string) => void;
  disabled: boolean;
  carrierList: any[];
};

interface Option {
  value: string;
  label: string;
};

const carrierDetails = (props: CarrierDetailsProps) => {

  const { classes } = props;
  const carrierOptions: Array<Option> = props.carrierList.map((item: any) => (
    {
      value: item.name,
      label: item.name
    }
  ));
  const iconStyle: string = props.carrier.value ? classes.green : classes.red;

  return (

    <div className={ securityDetailsStyles.inputsWrapper }>
      <Grid container direction="row" >
        <Grid item sm={ 10 } xs={ 11 } className={ `${ securityDetailsStyles.inputLabelWrapper } ${ securityDetailsStyles.iacField } ${ classes.selectcss }` } >
          <label className={ commonStyles.inputLabel }>Transferring Carrier</label>
          <Select
            className={ props.classes.select }
            options={ carrierOptions }
            value={ props.carrier }
            onChange={ (event: any) => props.handleChange(event, 'select') }
            placeholder='Enter Transferring Carrier'
            error={ props.carrier.value !== '' }
            InputProps={ {
              className: classes.textField,
              classes: { input: classes.input }
            } }
            isDisabled={ !props.disabled }
          />
        </Grid>
        <Grid item sm={ 2 } xs={ 1 } style={ { display: 'flex', alignItems: 'center' } } >
          { props.carrier.value &&
            <DotIcon className={ iconStyle } />
          }
        </Grid>
      </Grid>
    </div>

  );
};

export default withStyles(styles)(carrierDetails);